<h3 mat-dialog-title>Płatność ekspresowa chwilowo niedostępna</h3>

<div>Niestety płatność ekspresowa jest chwilowo niedostępna.</div>
<div>Możesz wykonać płatność standardową lub spróbować ponownie później.</div>

<div matDialogActions align="end">
  <button color="primary" mat-raised-button matDialogClose>Zamknij</button>
</div>
